import React from 'react';
import Selection from "@molecules/selection/selection";
import {FilterDispatcherContext} from "@providers/filters";
import {UpdateSelectionOptions} from "@hooks/selection.options";
import {useWindowSize} from "@helpers/windows.size";
import {isEmpty} from "@helpers/helpers";
import {getTypesOptions} from "../../../hooks/types";

function DealTypeSelection(props) {
    const windowSize = useWindowSize();
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    let {options, selected_items} = props.items;
    const selectedItemsCopy = [...selected_items];

    async function handleChange(data) {
        if (JSON.stringify(data.items) !== JSON.stringify(selectedItemsCopy)) {
            const new_option = await UpdateSelectionOptions(options, data);

            const newTypes = await getTypesOptions(props.city_id, (data.items.length ? data.items[0] : ''));
            const types_new_option = await UpdateSelectionOptions(newTypes.options, {items: props.typesSelectedItems});

            filterDispatcher({
                type: 'DEAL_TYPE_OPTIONS',
                payload: {
                    deal_type: new_option,
                    types: types_new_option
                }
            })
        }
    }

    return (
        <div className={typeof props.className !== "undefined" ? props.className : ''}>
            <Selection
                type="single"
                name={props.name ?? "deal_type"}
                options={options}
                selected_items={selected_items}
                label="نوع معامله"
                select_optional={(windowSize < 768)}
                onChange={(data) => handleChange(data)}
                showLabelAndSelected={!!(props.showLabelAndSelected)}
                loading={(!isEmpty(props.loading) && props.loading)}
            />
        </div>
    )
}

export default DealTypeSelection;

// styles
